module.exports = __webpack_public_path__ + "static/img/default_avatar3.24690a70.png";